import InputBase from '@mui/material/InputBase';
import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

export const SearchInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
        'borderRadius': 4,
        'position': 'relative',
        'backgroundColor': '#F3F6F9',
        'border': '1px solid',
        'borderColor': '#E0E3E7',
        'fontSize': 14,
        'width': '100%',
        'padding': '5px 6px',
        'transition': theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        'fontFamily': [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
        ...theme.applyStyles('dark', {
            backgroundColor: '#1A2027',
            borderColor: '#2D3843',
        }),
    },
}));
